module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "ded2"
  }, [_c('span', {
    attrs: {
      "aria-label": " page v. ",
      "epub:type": "pagebreak",
      "id": "page_v",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("To my husband, Tim—who is teaching me that “the M word” can be a good word—and to my editor, Jean Karl—who changed her initial “no” to “yes.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1561fbb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439132081/xhtml/dedication.vue
// module id = 63
// module chunks = 0